<template>
  <div class="authorize-list page-box">
    <query-header
      ref="header"
      :selected="selected"
      :product-list="productList"
      @toQuery="searchHandle"
      @add="addHandle"
      @delete="deleteHandle"
      @upload="uploadHandle"
      @export="exportHandle"
    ></query-header>
    <div class="page-content">
      <div class="vs-table-outer">
        <vs-table
          class="authorize-table"
          multiple
          v-model="selected"
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th class="id-col">
              ID
            </vs-th>
            <vs-th class="customer-info-col">
              客户信息
            </vs-th>
            <vs-th class="product-col">
              授权产品
            </vs-th>
            <vs-th class="type-col">
              类型
            </vs-th>
            <vs-th class="auth-code-col">
              授权码
            </vs-th>
            <vs-th class="validity-col">
              有效期
            </vs-th>
            <vs-th class="status-col">
              授权状态
            </vs-th>
            <vs-th class="bind-info-col">
              绑定信息
            </vs-th>
            <vs-th>
              推荐人
            </vs-th>
            <vs-th class="action-col">
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
              :data="tr"
            >
              <vs-td class="id-col">
                {{tr.id}}
              </vs-td>
              <vs-td class="customer-info-col">
                <template v-if="tr.userName || tr.phone">
                  <div>{{tr.userName || '-'}}</div>
                  <div>{{tr.phone || '-'}}</div>
                </template>
                <template v-else>
                  -
                </template>
              </vs-td>
              <vs-td
                class="product-col"
              >
                <el-popover
                  v-if="getOverFlow(tr)"
                  placement="top-start"
                  title="全部授权产品"
                  width="200"
                  trigger="hover"
                  :content="getContent(tr)">
                  <product-inner
                    slot="reference"
                    v-if="getOverFlow(tr)"
                    :product-list="productList"
                    :str-list="tr.authorizedProducts"
                  ></product-inner>
                </el-popover>
                <product-inner
                  v-if="!getOverFlow(tr)"
                  :product-list="productList"
                  :str-list="tr.authorizedProducts"
                ></product-inner>
              </vs-td>
              <vs-td class="type-col">
                {{ getAuthType(tr)}}
              </vs-td>

              <vs-td class="auth-code-col">
                <span
                  class="rap-normal"
                >{{tr.authorizationCode}}</span>
              </vs-td>
              <vs-td class="validity-col">
                <div>{{tr.beginDate}}</div>
                <div>{{tr.endDate}}</div>
              </vs-td>
              <vs-td class="status-col">
                <span
                  class="self-tag"
                  :style="getStyle(tr)"
                >{{getStatus(tr)}}</span>
              </vs-td>
              <vs-td class="bind-info-col">
                <el-popover
                  v-if="tr.bindPlatform || tr.bindLogin"
                  placement="top-start"
                  width="220"
                  trigger="hover"
                >
                  <div class="bind-info-content">
                    <div>平台：{{ tr.bindPlatform || '-' }}</div>
                    <div>Login：{{ tr.bindLogin || '-' }}</div>
                    <div>Mac：{{ tr.bindMac || '-' }}</div>
                  </div>
                  <div slot="reference" class="bind-info-cell" tabindex="0">
                    <div>{{ tr.bindPlatform || '-' }}</div>
                    <div>{{ tr.bindLogin || '-' }}</div>
                  </div>
                </el-popover>
                <template v-else>
                  -
                </template>
              </vs-td>
              <vs-td>
                {{tr.referrer || '-'}}
              </vs-td>
              <vs-td class="action-col">
                <el-button
                  type="text"
                  v-if="isAuth('auth:management:update')"
                  class="pointer"
                  @click.stop="editHandle(tr)"
                >修改</el-button>
                <el-button
                  type="text"
                  v-if="isAuth('auth:management:update') && hasBindInfo(tr)"
                  class="pointer"
                  @click.stop="unbindHandle(tr)"
                >解除限制</el-button>
                <el-button
                  type="text"
                  v-if="isAuth('auth:management:delete')"
                  class="pointer delete-btn"
                  @click.stop="deleteHandle(tr)"
                >删除</el-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
    <add-dialog
      :product-list="productList"
      :dialog-show="addDialogShow"
      @close="closeAddDialog"
      @add-success="addUserSuccess"
    ></add-dialog>
    <edit-dialog
      :product-list="productList"
      :row-data="currentRow"
      :dialog-show="editDialogShow"
      @close="closeEditDialog"
      @edit-success="editUserSuccess"
    ></edit-dialog>
    <multiple-delete-dialog
      ref="muldelete"
      :ids="ids"
      @sure-delete="confirmDelete"
    ></multiple-delete-dialog>
    <import-dialog
      :dialog-show="importShow"
      @close="importShow = false"
      @success="importSuccessHandle"
    ></import-dialog>
  </div>
</template>

<script>
import { export_json_to_excel,formatJson } from '@/vendor/Export2Excel'
import importDialog from "@/components/authorize/importDialog";
import multipleDeleteDialog from "@/components/public/multipleDeleteDialog";
import editDialog from '@/components/authorize/editDialog'
import addDialog from "@/components/authorize/addDialog";
import queryHeader from "@/components/authorize/queryHeader";
import { mapGetters } from 'vuex'
import { colorRgba,parseTime } from '@/utils/index'
import productInner from "@/components/authorize/productInner";
import initData from "@/mixins/initData";
import { deleteAuth, editAuth } from "@/api/authorize";
export default {
  name: "index",
  components: {
    addDialog,
    editDialog,
    queryHeader,
    multipleDeleteDialog,
    productInner,
    importDialog,
  },
  data() {
    return {
      selected: [],
      productList: [],
      red: '#D85E5F',
      green: '#41B883',
      addDialogShow: false,
      editDialogShow: false,
      currentRow: {},
      ids: [],
      importShow: false,
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo']),
  },
  created(){
    this.getProducts();
  },
  mounted(){
    this.init();
  },
  methods: {
    parseTime,
    beforeInit(){
      this.url = '/wx/manage/authorization/list';
      this.params = {
        page: this.page,
        limit: this.size,
        'sidx': 'id',
        'order': 'desc'
      }
      let header = this.$refs.header;
      if(header.status !== ''){
        this.params.status = header.status;
      }
      if(header.productType){
        this.params.productId = header.productType;
      }
      if(header.customerInfo){
        this.params.userInfo = header.customerInfo;
      }
      if(header.recommenInfo){
        this.params.referrer = header.recommenInfo;
      }
      if(header.type){
        this.params.type = header.type;
      }
      return true;
    },

    getProducts(){
      this.$http({
        url: '/wx/manage/authorizedProduct/all',
        method: 'get',
      }).then((data) => {
        if (data && data.code === 200) {
          this.productList = data.data;
        } else {
          this.dataList = []
        }
      })
    },
    getContent(row){
      let handlerArr = row.authorizedProducts.split(',');
      let textArr = [];
      for (let i = 0; i < this.productList.length; i++) {
        if(handlerArr.indexOf(String(this.productList[i].id)) > - 1){
          textArr.push(this.productList[i].productName + `(${this.productList[i].productCode})`);
        }
      }
      return textArr.join(';');
    },
    getOverFlow(row){
      if(row.authorizedProducts.split(',').length > 3){
        return true;
      }else {
        return false;
      }
    },
    getStatus(row){
      switch (row.status){
        case 1:
          return `有效 (剩余${row.remainingDays}天)`;
        case 0:
          return '失效';
      }
    },
    getAuthType(row){
      switch (row.type){
        case 1:
          return '普通码';
        case 2:
          return '试用码';
        case 3:
          return '每日授权码';
      }
    },
    getStyle(tr){
      if(tr.status === 0){
        return {
          backgroundColor: colorRgba(this.red ,0.1),
          color: this.red,
        };
      }else {

        return {
          backgroundColor: colorRgba(this.green,0.1),
          color: this.green,
        };
      }
    },
    addHandle(){
      setTimeout(() => {
        this.addDialogShow = true;
      },200);
    },
    addUserSuccess(){
      this.addDialogShow = false;
      this.searchHandle();
    },
    // 上传表格 todo
    uploadHandle(){
      this.importShow = true;
    },
    // 只负责刷新列表：有失败行时弹窗要留着给用户看明细，
    // 关闭统一由弹窗自己的 close 事件负责
    importSuccessHandle(){
      this.searchHandle();
    },
    editHandle(row){
      this.currentRow = row;
      setTimeout(() => {
        this.editDialogShow = true;
      },200);
    },
    hasBindInfo(row){
      return [row.bindPlatform, row.bindLogin, row.bindMac].some(item => item !== null && item !== undefined && item !== '');
    },
    unbindHandle(row){
      this.$confirm('确认解除该授权码的绑定限制？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          id: row.id,
          userName: row.userName,
          phone: row.phone,
          authorizedProducts: row.authorizedProducts,
          beginDate: row.beginDate,
          endDate: row.endDate,
          bindPlatform: '',
          bindLogin: '',
          bindMac: '',
          type: row.type,
        };
        if(row.referrer){
          params.referrer = row.referrer;
        }
        editAuth(params).then((res) => {
          if(res && res.code === 200){
            this.$message({
              message: '解除限制成功',
              type: 'success',
            });
            this.searchHandle();
          }else {
            this.$message({
              message: res && res.msg ? res.msg : '解除限制失败',
              type: 'error'
            });
          }
        }).catch((err) => {
          this.$message.error(err && err.msg ? err.msg : '解除限制失败');
        });
      }).catch(() => {});
    },
    editUserSuccess(){
      this.currentRow = {}
      this.editDialogShow = false;
      this.searchHandle();
    },
    closeEditDialog(){
      this.currentRow = {}
      this.editDialogShow = false;
    },
    deleteHandle(row){
      this.ids = row ? [row.id] : this.selected.map(item => item.id);
      this.$refs.muldelete.dialogShow = true;
    },
    confirmDelete(ids){
      deleteAuth(ids).then(() => {
        this.$message({
          type: 'success',
          message: '已删除'
        });
        this.$refs.muldelete.dialogShow = false;
        this.searchHandle();
      })
    },
    closeAddDialog(){
      this.addDialogShow = false;
    },
    exportHandle(){
      if(this.selected.length == 0){
        this.$message({
          type: 'warning',
          message: '请勾选'
        });
        return;
      }
      for (let i = 0; i < this.selected.length; i++) {
        this.selected[i].handlerStatus = this.getStatus(this.selected[i]);
      }
      const tHeader =['ID','客户姓名','手机','授权产品','授权码','开始日期', '结束日期','状态','平台','Login','推荐人'];
      const filterVal =['id','userName','phone','productNames','authorizationCode','beginDate','endDate','handlerStatus','bindPlatform','bindLogin','referrer'];
      const exportData = formatJson(filterVal,this.selected);
      let fileName='授权管理';
      export_json_to_excel(tHeader,exportData,fileName);
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
  },
}
</script>

<style lang="scss" scoped>
.authorize-list {
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    .vs-con-table {
    }
  }
  .authorize-table {
    min-width: 1320px;
  }
  .id-col {
    min-width: 56px;
    white-space: nowrap;
  }
  .customer-info-col {
    min-width: 140px;
  }
  .product-col {
    min-width: 190px;
  }
  .type-col {
    min-width: 100px;
    white-space: nowrap;
  }
  .auth-code-col {
    min-width: 230px;
  }
  .validity-col {
    min-width: 120px;
  }
  .status-col {
    min-width: 160px;
  }
  .bind-info-col {
    min-width: 250px;
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
  .bind-info-cell {
    line-height: 1.5;
    white-space: nowrap;
  }
  .bind-info-content {
    line-height: 1.5;
    white-space: nowrap;
  }
  .action-col {
    min-width: 160px;
    white-space: nowrap;
  }
  .reject-reason {
    max-width: 120px;
  }
}

@media screen and (max-width: 768px) {
  .authorize-list {
    .pagination-outer {
      flex-direction: column;
      align-items: stretch;
      gap: 12px;
      overflow: hidden;
      padding-left: 20px;
      padding-right: 20px;
    }

    .paginnation-left {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 8px;
    }

    .pagination-box {
      width: 100%!important;
      justify-content: flex-start!important;
      overflow-x: auto;
      overflow-y: hidden;
      -webkit-overflow-scrolling: touch;
    }

    /deep/ .vs-pagination--nav {
      width: max-content;
      min-width: 100%;
    }

    /deep/ .vs-pagination--buttons {
      width: 32px;
      min-width: 32px;
      height: 32px;
      margin-left: 2px;
      margin-right: 2px;
    }

    /deep/ .vs-pagination--li {
      width: 28px;
      min-width: 28px;
      height: 28px;
      margin-left: 1px;
      margin-right: 1px;
    }
  }
}
</style>
